<template>
  <div>
    <v-container>
      <v-card
        :loading="false"
      >
        <v-overlay
          :absolute="true"
          :value="isComponentLoading"
        >
          <v-progress-circular indeterminate size="24"></v-progress-circular>
        </v-overlay>
        <v-row class="pa-2">
          <v-col>
            <div v-if="stats" style="max-width: 100%; overflow-x: auto;">
              <table id="customers">
                <thead>
                <tr>
                  <th>

                  </th>
                  <th>
                    {{ $t('stats.showmy.order_base') }}
                    <!--base_simple_order-->
                  </th>
                  <th>
                    {{ $t('stats.showmy.order_complex') }}
                    <!--complex_order-->
                  </th>
                  <th>
                    {{ $t('stats.showmy.dry_cleaning') }}
                    <!--dry_cleaning_order-->
                  </th>
                  <th>
                    {{ $t('stats.showmy.subscriptions') }}
                    <!--subscription-->
                  </th>
                  <th>
                    {{ $t('stats.showmy.order_subscriptions') }}
                    <!--base_subscription_order-->
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td style="text-align: center; background-color: #330000; color: white">
                    {{ $t('stats.showmy.all_time') }} <br>
                    ({{ $t('stats.showmy.without_cur_day') }})
                  </td>
                  <template v-if="stats.total">
                    <td>
                      {{ stats.total.base_simple_order ? stats.total.base_simple_order : '-' }}
                    </td>
                    <td>
                      {{ stats.total.complex_order ? stats.total.complex_order : '-' }}
                    </td>
                    <td>
                      {{ stats.total.dry_cleaning_order ? stats.total.dry_cleaning_order : '-' }}
                    </td>
                    <td>
                      {{ stats.total.subscription ? stats.total.subscription : '-' }}
                    </td>
                    <td>
                      {{ stats.total.base_subscription_order ? stats.total.base_subscription_order : '-' }}
                    </td>
                  </template>
                  <template v-else>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                  </template>
                </tr>
                <tr>
                  <td style="text-align: center; background-color: #330000; color: white">
                    {{ $t('stats.showmy.last_month') }}
                  </td>

                  <template v-if="stats.last_month">
                    <td>
                      {{ stats.last_month.base_simple_order ? stats.last_month.base_simple_order : '-' }}
                    </td>
                    <td>
                      {{ stats.last_month.complex_order ? stats.last_month.complex_order : '-' }}
                    </td>
                    <td>
                      {{ stats.last_month.dry_cleaning_order ? stats.last_month.dry_cleaning_order : '-' }}
                    </td>
                    <td>
                      {{ stats.last_month.subscription ? stats.last_month.subscription : '-' }}
                    </td>
                    <td>
                      {{ stats.last_month.base_subscription_order ? stats.last_month.base_subscription_order : '-' }}
                    </td>
                  </template>
                  <template v-else>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                  </template>
                </tr>
                <tr>
                  <td style="text-align: center; background-color: #330000; color: white">
                    {{ $t('stats.showmy.cur_month') }}
                  </td>

                  <template v-if="stats.current_month">
                    <td>
                      {{ stats.current_month.base_simple_order ? stats.current_month.base_simple_order : '-' }}
                    </td>
                    <td>
                      {{ stats.current_month.complex_order ? stats.current_month.complex_order : '-' }}
                    </td>
                    <td>
                      {{ stats.current_month.dry_cleaning_order ? stats.current_month.dry_cleaning_order : '-' }}
                    </td>
                    <td>
                      {{ stats.current_month.subscription ? stats.current_month.subscription : '-' }}
                    </td>
                    <td>
                      {{ stats.current_month.base_subscription_order ? stats.current_month.base_subscription_order : '-' }}
                    </td>
                  </template>
                  <template v-else>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                  </template>
                </tr>
                <tr>
                  <td style="text-align: center; background-color: #330000; color: white">
                    {{ $t('stats.showmy.today') }}
                  </td>
                  <template v-if="stats.today">
                    <td>
                      {{ stats.today.base_simple_order ? stats.today.base_simple_order : '-' }}
                    </td>
                    <td>
                      {{ stats.today.complex_order ? stats.today.complex_order : '-' }}
                    </td>
                    <td>
                      {{ stats.today.dry_cleaning_order ? stats.today.dry_cleaning_order : '-' }}
                    </td>
                    <td>
                      {{ stats.today.subscription ? stats.today.subscription : '-' }}
                    </td>
                    <td>
                      {{ stats.today.base_subscription_order ? stats.today.base_subscription_order : '-' }}
                    </td>
                  </template>
                  <template v-else>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                  </template>
                </tr>
                </tbody>
              </table>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import StatsCreatedProxy from '@/proxies/Stats/StatsCreatedProxy';

export default {
  mixins: [updatePageContentMixin],
  name: 'ShowMy',
  data() {
    return {
      isComponentLoading: false,
      stats: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isComponentLoading = true;
      new StatsCreatedProxy().showMy()
        .then((response) => {
          this.stats = response.data.data.stats;
        })
        .finally(() => {
          this.isComponentLoading = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
  },
};
</script>

<style>
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}

#customers td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #4CAF50;
  color: white;
}

#customers .bolder-row {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #af5149;
  color: white;
}
</style>
